import React, { useState } from 'react'
import { baseUrl } from '../../../services/config';
import SendNotification from '../Send-Notification/SendNotification'
import toast from 'react-hot-toast';

const NotificationSend = () => {
    const [show, setshow] = useState(true)
    const authToken = localStorage.getItem("userToken");
    const [list, setlist] = useState([])
    const [checkboxValues, setCheckboxValues] = useState({
        all: '0',
        join_club: '0',
        foldable_join_club: '0'
    })


    // Handle checkbox changes
    const handleCheckboxChange = (key, value) => {
        const updatedValues = {
            ...checkboxValues,
            [key]: value
        };
        
        setCheckboxValues(updatedValues);
        
        // Fetch device IDs with updated values
        // fetchDeviceIds(updatedValues);
    }

    // Function to send notification
    const handleSendNotification = async (notificationData) => {
        try {
            const response = await fetch(`${baseUrl}/admin/users/device-id`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
                body: notificationData
            });

            const data = await response.json();

            if (data.success || data.metadata?.success) {
                return data;
            } else {
                throw new Error(data.message || "Failed to send notification");
            }
        } catch (err) {
            console.error("Error sending notification:", err);
            throw err;
        }
    }

    return (
        <div>
            <SendNotification
                listokens={list}
                show={show}
                hideModal={() => setshow(false)}
                onCheckboxChange={handleCheckboxChange}
                onSendNotification={handleSendNotification}
            />
        </div>
    )
}

export default NotificationSend